(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/tips-info-data-collection.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/tips-info-data-collection.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.TipsInfoDataCollection = Backbone.Collection.extend(
    {
      log: new svs.core.log.Logger('svs.collections.Matchlist'),
      model: svs.maltipset.models.TipsInfoDataModel,

      getPath: function() {
        var lastMatchesPath,
          lastMatchesArr = [],
          self = this,
          teamIds;
        _.each(
          svs.maltipset.collections.coupons
            .getCurrentCoupon()
            .get('draw')
            .get('matchList')
            .getAllMatches(),
          function(team) {
            if (!team.get('isPlayer')) {
              teamIds = team.getTeamIds();
              lastMatchesArr.push(
                '/sport/1/teams/' + teamIds.homeTeamId + '/lastmatches?count=5'
              );
              lastMatchesArr.push(
                '/sport/1/teams/' + teamIds.awayTeamId + '/lastmatches?count=5'
              );
              self.add(
                new svs.maltipset.models.TipsInfoDataModel(teamIds.homeTeamId)
              );
              self.add(
                new svs.maltipset.models.TipsInfoDataModel(teamIds.awayTeamId)
              );
            }
          }
        );

        lastMatchesPath = lastMatchesArr.join('|');

        return lastMatchesPath;
      },

      url: function() {
        svs.events.publish('/loader/show');
        var newUrl = '/multifetch?urls=' + encodeURIComponent(this.getPath());

        return svs.core.jupiter.url() + newUrl;
      },

      parse: function(response) {
        _.each(this.models, function(match, index) {
          if (
            response &&
            response.responses &&
            response.responses[index] &&
            response.responses[index].result
          ) {
            match.setLastMatchValues(response.responses[index].result);
          }
        });
        svs.events.publish('/loader/hide');
        this.trigger('lastMatchesReady');
      },

      getTipsInfoDataByTeamId: function(id) {
        return this.findWhere({ teamId: id });
      }
    }
  );
})(Backbone, _, svs);

 })(window);